// shopHelper.js
import { fetchData } from "./utils";
import axios from "axios";
const baseUrl = process.env.REACT_APP_BASE_URL;
// const reactUrl = process.env.REACT_APP_FRONTEND_URL || 'http://127.0.0.1:3000'
const reactUrl = 'http://localhost:3000'
// const payuKey = process.env.REACT_APP_PAYU_KEY || "3oa0EG";
const payuKey = "gYfjTS";

export const fetchProducts = async (access_token) => {
  try {
    const productsData = await fetchData(
      "products",
      { skip: 0, limit: 10, schema: "public" },
      access_token
    );
    return productsData.sort((a, b) => a.price - b.price);
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const fetchAddonProducts = async () => {
    try {
      const productsData = await fetchData(
        "products/addon",
        { schema: "public" }
      );
      return productsData;
    } catch (error) {
      console.error("Error fetching products:", error);
      throw error;
    }
  };

export const fetchAddOnServices = async (productId) => {
  try {
    const servicesData = await fetchData(
      `product_add_on_mapping/filter`,
      { product_id: productId, schema: "public" }
    );

    const addOnServicesDetails = await Promise.all(
      servicesData.map(async (service) => {
        const serviceDetails = await fetchData(
          `add_on_services/${service.add_on_s_id}`,
          { schema: "public" }
        );
        return {
          ...service,
          name: serviceDetails.name,
        };
      })
    );

    return addOnServicesDetails;
  } catch (error) {
    console.error("Error fetching add-on services:", error);
    throw error;
  }
};

export const addToCart = async (cartData, access_token) => {
  try {
    const response = await axios.post(
      `${baseUrl}/cart_items/`,
      cartData,
      {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );
    return response;
  } catch (error) {
    console.error("Error adding to cart:", error);
    throw error;
  }
};

export const updateCart = async (cartItemId, updatedCartData, access_token) => {
  try {
    const response = await axios.put(
      `${baseUrl}/cart_items?id=${cartItemId}`,
      updatedCartData,
      {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );
    return response;
  } catch (error) {
    console.error("Error updating cart:", error);
    throw error;
  }
};

export const deleteCartItems = async (cartItemId, access_token) => {
  try {
    const response = await axios.delete(
      `${baseUrl}/cart_items/${cartItemId}`,
      {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );
    return response;
  } catch (error) {
    console.error("Error deleting cart items:", error);
    throw error;
  }
};

export const fetchCart = async (user_id, access_token) => {
  try {
    const cartResponse = await fetchData(
      `cart/filter`,
      { user_id, schema: "public" }
    );

    if (cartResponse && cartResponse.id) {
      return cartResponse.id;
    }
    
    // If no cart found, create a new one
    const cartData = {
      user_id,
      created_at: new Date().toISOString()
    };
    const createResponse = await createCart(cartData, access_token);
    return createResponse.data.id;

  } catch (error) {
    
    // Check if error message contains "No data found for user_id"
    const errorMessage = error?.message || error?.response?.data?.detail || '';
    if (errorMessage.includes("No data found for user_id")) {
      const cartData = {
        user_id,
        created_at: new Date().toISOString()
      };
      const createResponse = await createCart(cartData, access_token);
      return createResponse.data.id;
    }
    
    throw error;
  }
};

export const createCart = async (cartData, access_token) => {

  try {
    const response = await axios.post(
      `${baseUrl}/cart/`,
      {
        ...cartData,
        status: "initiated", // Adding status to the cart data
      },
      {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );
    return response;
  } catch (error) {
    console.error("Error creating cart:", error);
    throw error;
  }
};

export const fetchCartItemsAndCartItems = async (user_id, access_token) => {
    try {
  
      const cartResponse = await fetchData(
        `cart/filter`,
        {user_id, schema: "public" }
      );
      if (!cartResponse || cartResponse.length === 0) {
        return { cartItems: [], cart_id: null };
      }
  
      const cart_id = cartResponse.id;

  
      const cartItemsResponse = await fetchData(
        `cart_items/filter_by_user_id_cart_id`,
        {user_id, cart_id, schema: "public" }
      );
      return { cartItems: cartItemsResponse, cart_id };
    } catch (error) {
      console.error("Error fetching cart items:", error);
      throw error;
    }
  };
  
  export const fetchProductDetailsForCart = async (cartItems) => {
    const updatedCartItems = await Promise.all(
      cartItems.map(async (item) => {
        try {
        //   const productResponse = await axios.get(
        //     `${baseUrl}/products/${item.product_id}?schema=public`
        //   );

          const productResponse = await fetchData(
            `products/${item.product_id}`,
            {schema: "public" }
          );

          return {
            ...item,
            productDetails: {
              name: productResponse.data.name,
              product_image: productResponse.data.product_image,
              id: productResponse.data.id,
            },
          };
        } catch (error) {
          console.error("Error fetching product details for item:", item.product_id);
          return item;
        }
      })
    );
    return updatedCartItems;
  };
  
  export const applyCoupon = async (couponCode) => {
    try {
      const response = await axios.post(`$/apply_coupon`, {
        coupon_code: couponCode,
      });
      return response.data.discount;
    } catch (error) {
      console.error("Error applying coupon:", error);
      throw error;
    }
  };
  
// New reusable methods
export const fetchCartAndItems = async (user_id, access_token) => {
  try {
    // Get cart ID first
    const cartResponse = await axios.get(`${baseUrl}/cart/filter`, {
      params: { user_id },
      headers: { Authorization: `Bearer ${access_token}` },
    });

    if (!cartResponse.data || !cartResponse.data.id) {
      return { cartItems: [], loading: false };
    }

    const cart_id = cartResponse.data.id;

    // Get cart items
    const cartItemsResponse = await axios.get(`${baseUrl}/cart_items/filter_by_user_id_cart_id`, {
      params: { user_id, cart_id },
      headers: { Authorization: `Bearer ${access_token}` },
    });

    if (!cartItemsResponse.data || cartItemsResponse.data.length === 0) {
      return { cartItems: [], loading: false };
    }

    const cartItems = cartItemsResponse.data;
    const updatedCartItems = await fetchProductDetailsForCartItems(cartItems, access_token);
    
    return { cartItems: updatedCartItems, loading: false };
  } catch (error) {
    console.error("Error fetching cart items:", error);
    return { cartItems: [], loading: false };
  }
};

export const fetchProductDetailsForCartItems = async (cartItems, access_token) => {
  try {
    const updatedCartItems = await Promise.all(
      cartItems.map(async (item) => {
        try {
          const productResponse = await axios.get(
            `${baseUrl}/products/${item.product_id}`,
            {
              params: { schema: "public" },
              headers: { Authorization: `Bearer ${access_token}` },
            }
          );

          return {
            ...item,
            productDetails: {
              name: productResponse.data.name,
              product_image: productResponse.data.product_image,
              id: productResponse.data.id,
              type: productResponse.data.type,
              unit_price: item.unit_price
            },
          };
        } catch (error) {
          console.error(`Error fetching product details for item ${item.product_id}:`, error);
          return item;
        }
      })
    );
    return updatedCartItems;
  } catch (error) {
    console.error("Error in fetchProductDetailsForCart:", error);
    return cartItems;
  }
};

export const createOrder = async (orderData, access_token) => {
  try {
    const response = await axios.post(
      `${baseUrl}/orders/`,
      orderData,
      {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );
    if (response.status === 200) {
      await updateCartStatus(orderData.cart_id, "placed", orderData.user_id, access_token);
    } else {
      console.error("Error creating order:", response);
    } 
    return response;
  } catch (error) {
    console.error("Error creating order:", error);
    throw error;
  }
};
 
// needs implementation
export const fetchOrderDetails = async (orderId, access_token) => {
  try {
    const response = await axios.get(`${baseUrl}/orders/${orderId}`, {
      params: { schema: "public" },
      headers: { Authorization: `Bearer ${access_token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching order details:", error);
    throw error;
  }
};

export const updateCartStatus = async (cartId, status, user_id, access_token) => {
const updatedData = {
  user_id: user_id,
  status: status,
  updated_at: new Date().toISOString()
}
  try {
    const response = await axios.put(`${baseUrl}/cart/${cartId}`,
      updatedData,
      {
      params: { schema: "public" },   
      headers: { Authorization: `Bearer ${access_token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating cart status:", error);
    throw error;      
  }
};

// 1. First, create a draft order
export const createInitiatedOrder = async (orderData, access_token) => {
  try {
    const response = await axios.post(
      `${baseUrl}/orders/`,
      { 
        ...orderData,
        order_status: "pending", // Initial status
        order_no: "123"
      },
      {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating draft order:", error);
    throw error;
  }
};

// 2. Initiate payment with the draft order ID
export const initiatePayment = async (paymentData, access_token) => {
  try {
    const response = await axios.post(
      `${baseUrl}/payments/payu/initiate`,
      paymentData,
      {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error initiating payment:", error);
    throw error;
  }
};

// 3. Update order status after successful payment
export const finalizeOrder = async (orderId, paymentDetails, access_token) => {
  try {
    const response = await axios.put(
      `${baseUrl}/orders/${orderId}`,
      {
        status: "confirmed",
        payment_details: paymentDetails
      },
      {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );

    if (response.status === 200) {
      await updateCartStatus(response.data.cart_id, "placed", response.data.user_id, access_token);
    }

    return response.data;
  } catch (error) {
    console.error("Error finalizing order:", error);
    throw error;
  }
};

// Usage example in your checkout component
export const handleCheckoutProcess = async (orderData, access_token) => {
  try {
    // 1. Create draft order
    const initiatedOrder = await createInitiatedOrder(orderData, access_token);

    // Validate and format amount
    const amount = Number(initiatedOrder.total_amount);
    if (isNaN(amount) || amount <= 0) {
      throw new Error('Invalid amount');
    }
    const formattedAmount = amount.toFixed(2);

    // 2. Prepare payment request
    const paymentRequest = {
      // Mandatory Parameters for PayU
      key: String(payuKey),
      txnid: String(initiatedOrder.id),
      amount: formattedAmount,
      productinfo: String(`Order #${initiatedOrder.id}`),
      firstname: String(orderData.full_name),
      email: String(orderData.email),
      phone: String(orderData.mobile),
      surl: `${window.location.origin}/payment/response`, // Success URL
      furl: `${window.location.origin}/payment/response`, // Failure URL
      
      // Optional parameters
      lastname: '',
      curl: String(`${process.env.REACT_APP_BASE_URL}/payment/cancel`),
      address1: String(orderData.shipping_address || ''),
      city: '',
      state: '',
      country: 'India',
      zipcode: '',
      udf1: '',
      udf2: '',
      udf3: '',
      udf4: '',
      udf5: '',
      pg: ''
    };
    console.log(paymentRequest);

    // 3. Get payment response with hash
    const paymentResponse = await initiatePayment(paymentRequest, access_token);
    
    sessionStorage.setItem('currentOrderId', String(initiatedOrder.id));
    
    // 4. Create and submit form
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = paymentResponse.payment_url;

    // Add all payment details as hidden form fields, INCLUDING the hash
    const allParameters = {
      ...paymentRequest,
      hash: paymentResponse.hash // Add the hash from the payment response
    };

    Object.entries(allParameters).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = String(value);
        form.appendChild(input);
      }
    });

    document.body.appendChild(form);
    form.submit();

    return paymentResponse;
  } catch (error) {
    console.error("Checkout process failed:", error);
    throw error;
  }
};

// Handle payment callback/verification
export const verifyAndFinalizeOrder = async (paymentDetails, access_token) => {
  try {
    const orderId = sessionStorage.getItem('currentOrderId');
    if (!orderId) {
      throw new Error('Order ID not found');
    }

    // Verify payment status
    const paymentStatus = await axios.get(
      `${baseUrl}/payments/payu/status/${paymentDetails.transaction_id}`,
      {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );

    if (paymentStatus.data.status === 'success') {
      // Finalize the order
      const finalizedOrder = await finalizeOrder(orderId, paymentDetails, access_token);
      sessionStorage.removeItem('currentOrderId');
      return finalizedOrder;
    } else {
      throw new Error('Payment verification failed');
    }
  } catch (error) {
    console.error("Order finalization failed:", error);
    throw error;
  }
};

